<template>
  <div class="summary col-md-4 bg-light p-4">
    <h2>Sammanställning</h2>
    <strong>{{ formConfig.steps[0].title }}</strong>
    <div v-for="(value, key) in formData" :key="key">
      <strong>{{ getLabel(key) }}</strong>: 
      <span v-if="Array.isArray(value) && value.length">
        {{ value.join(', ') }}
      </span>
      <span v-else>
        {{ value || '-' }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['formData', 'formConfig'],
  methods: {
    getLabel(id) {
      for (let step of this.formConfig.steps) {
        for (let q of step.questions) {
          if (q.id === id) return q.label.replace('*', '');
        }
      }
      if(id === "wpphone") return "Telefon";
      else if(id === "wpemail") return "E-mail";
      else if(id === "wpname") return "Namn";
      //else if(id === "service") return this.formConfig.steps[0].title;
      return id;
    }
  }
};
</script>

<style>
.summary {
  border:1px solid #ccc;
  border-radius:14px;
  background: #f5f5f5;
}
h2 {
  margin-bottom: 20px;
}
</style>
